import { Vue, Component, Prop, Watch, Setup } from "@wagich/vue-facing-decorator-metadata";

import { CustomFormField } from "../custom-form-field";
import { render } from "./checkbox-field.html";
import { enforce, test } from "vest";

@Component({
	render
})
export class CheckboxField extends CustomFormField {
	get isChecked() {
		return this.modelValue === true;
	}

	createValidator(data: any) {
		if (this.field.required) {
			test(this.field.name, "Dieses Feld muss aktiviert sein, um das Formular abschicken zu können.", () => {
				enforce(data[this.field.name]).equals(true);
			});
		}
	}
}
